import { useEffect } from "react";
import { $generateNodesFromDOM } from "@lexical/html";
import { $getRoot, $insertNodes } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

type LoadHtmlPluginProps = {
	htmlContent: string;
    shouldLoad: boolean;
};

export default function LoadHtmlPlugin(props: LoadHtmlPluginProps) {
	const { htmlContent, shouldLoad } = props;

	const [editor] = useLexicalComposerContext();

	useEffect(() => {
		if (!htmlContent || !shouldLoad) {
			return;
		}

		editor?.update(() => {
			const parser = new DOMParser();
			const dom = parser.parseFromString(htmlContent, "text/html");

			const nodes = $generateNodesFromDOM(editor, dom);
            const root = $getRoot();
            root.clear();
			$getRoot().select();
			$insertNodes(nodes);

			$getRoot().selectStart();
		});
	}, [editor, htmlContent, shouldLoad]);

	return null;
}
